import { render, staticRenderFns } from "./MaterialSetting.vue?vue&type=template&id=f4995894&scoped=true"
import script from "./MaterialSetting.vue?vue&type=script&lang=js"
export * from "./MaterialSetting.vue?vue&type=script&lang=js"
import style0 from "./MaterialSetting.vue?vue&type=style&index=0&id=f4995894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4995894",
  null
  
)

export default component.exports